import React from 'react';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const SectionMenuLayout = ({ label, sections, activeId, onSectionChange, children }) => (
  <div className={styles.materialsLayout}>
    <nav className={`dct-menu__panel ${styles.materialsMenu}`} aria-label={label}>
      <ul className="dct-menu__list">
        {sections.map((section) => {
          const isCurrent = section.id === activeId;
          return (
            <li key={section.id}>
              <a
                href={`#${section.id}`}
                className={isCurrent ? 'dct-menu__link is-current' : 'dct-menu__link'}
                aria-current={isCurrent ? 'page' : undefined}
                onClick={(event) => {
                  event.preventDefault();
                  onSectionChange(section.id);
                }}
              >
                {t(section.label)}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>

    <div className={styles.materialsContent}>{children}</div>
  </div>
);

export const activeSubsection = (sections, activeSection) => (
  sections.find((section) => section.id === activeSection) || sections[0]
);

export default SectionMenuLayout;
